const AUTH_DESIGN_SESSION_KEY = 'descope-universal-login:auth-design-decision';

// `descope-universal-login:new-register-design` stores the experiment arm
// assignment and remains authoritative for that experiment. This separate
// `descope-universal-login:auth-design-decision` key records the design used
// by shared screens during the current auth attempt. The arm key is latched
// on signup and is not cleared by login; this key is written by the signup
// page, cleared by direct-login entry, and preserved when Login page follows a
// latched returning-user OTP within the same mounted app.
export const readAuthDesignDecision = (): boolean => {
  try {
    return sessionStorage.getItem(AUTH_DESIGN_SESSION_KEY) === 'true';
  } catch {
    return false;
  }
};

export const writeAuthDesignDecision = (decision: boolean): void => {
  try {
    sessionStorage.setItem(AUTH_DESIGN_SESSION_KEY, String(decision));
  } catch {
    // Blocked storage degrades to the legacy screen consistently.
  }
};
